import { SpecialtyTherapistModel } from '@/modules/schedule/domain/models/SpecialtyTherapistModel'

import { axios, Response } from '../index'

export const specialtyForTherapist = (
  therapistId: string
): Response<SpecialtyTherapistModel> => {
  return axios.get(`/v1/therapists/${therapistId}/specialties`)
}
